import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import dynamic from 'next/dynamic';
import classes from './NotificationContainer.module.scss';

const ToastContainer = dynamic(() => import('react-toastify').then((lib) => lib.ToastContainer));

const NotificationContainer = () => (
  <ToastContainer
    className={classes.Container}
    toastClassName={classes.Toast}
    bodyClassName={classes.Toast__Body}
    progressClassName={classes.Toast__Progress}
    position="bottom-center"
    closeButton={false}
    autoClose={4000}
    draggableDirection="y"
    icon={false}
    closeOnClick={false}
  />
);

export default NotificationContainer;
